import type { SelectOption } from './SelectBase';

export const getSelectOptionValue = <T>(option: SelectOption<T>) =>
  `${option.label} ${option.searchText ?? ''} ${String(option.value)}`;
